import React from 'react';
import { HelpCircle, Check, X, Package } from 'lucide-react';
import type { UnmatchedAccessory } from '../utils/xmlParser';

interface XmlUnmatchedModalProps {
  isOpen: boolean;
  unmatchedAccessories: UnmatchedAccessory[];
  onConfirm: (includeUnmatched: boolean) => void;
}

export const XmlUnmatchedModal: React.FC<XmlUnmatchedModalProps> = ({
  isOpen,
  unmatchedAccessories,
  onConfirm,
}) => {
  if (!isOpen || unmatchedAccessories.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/60 backdrop-blur-sm animate-in fade-in duration-150 no-print">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 border border-stone-200 animate-in zoom-in-95 duration-200 space-y-5">
        
        {/* Header Icon & Title */}
        <div className="flex items-start space-x-3.5">
          <div className="w-10 h-10 rounded-xl bg-amber-50 border border-amber-200 flex items-center justify-center shrink-0">
            <HelpCircle className="w-6 h-6 text-amber-600" />
          </div>
          <div>
            <h3 className="font-extrabold text-stone-900 text-base tracking-tight">
              Katalogla Eşleşmeyen Aksesuarlar
            </h3>
            <p className="text-xs text-stone-500 mt-0.5 font-medium leading-relaxed">
              Yüklediğiniz XML dosyasında katalogla doğrudan eşleşmeyen aksesuarlar tespit edildi.
            </p>
          </div>
        </div>

        {/* Question Highlight */}
        <div className="bg-stone-50 border border-stone-200/80 rounded-xl p-4 space-y-2.5">
          <p className="text-xs font-bold text-stone-850 leading-normal">
            Katalogla eşleşmeyen aksesuarların eklenmesini ister misiniz?
          </p>

          {/* Code Badges List */}
          <div className="space-y-1 pt-1">
            <div className="text-[10px] font-bold uppercase tracking-wider text-stone-400 flex items-center space-x-1">
              <Package className="w-3 h-3 text-stone-400" />
              <span>Tespit Edilen Aksesuarlar ({unmatchedAccessories.length} Adet):</span>
            </div>
            <div className="flex flex-wrap gap-1.5 max-h-28 overflow-y-auto pt-1 pr-1 custom-scrollbar">
              {unmatchedAccessories.map((acc, idx) => (
                <span
                  key={idx}
                  className="bg-white border border-stone-200 text-stone-800 font-mono text-[11px] font-bold px-2.5 py-0.5 rounded-md shadow-2xs"
                  title={acc.name !== acc.code ? acc.name : undefined}
                >
                  {acc.code}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center space-x-3 pt-1">
          <button
            type="button"
            onClick={() => onConfirm(true)}
            className="flex-1 bg-brand-600 hover:bg-brand-700 active:bg-brand-800 text-white text-xs font-extrabold py-3 px-4 rounded-xl shadow-md transition-all flex items-center justify-center space-x-1.5 cursor-pointer hover:scale-[1.02]"
          >
            <Check className="w-4 h-4" />
            <span>Evet (Hepsini Ekle)</span>
          </button>
          
          <button
            type="button"
            onClick={() => onConfirm(false)}
            className="flex-1 bg-stone-100 hover:bg-stone-200 active:bg-stone-300 text-stone-700 text-xs font-bold py-3 px-4 rounded-xl border border-stone-250 transition-all flex items-center justify-center space-x-1.5 cursor-pointer"
          >
            <X className="w-4 h-4 text-stone-500" />
            <span>Hayır (Sadece Eşleşenler)</span>
          </button>
        </div>

      </div>
    </div>
  );
};
